
import { useFreeResponse } from "./useFreeResponse";
import { FreeResponseProvider } from "./FreeResponseContext";
import { FreeResponseLoading } from "./FreeResponseLoading";
import { FreeResponseEmpty } from "./FreeResponseEmpty";
import { FreeResponseCompleted } from "./FreeResponseCompleted";
import { FreeResponseForm } from "./FreeResponseForm";

interface FreeResponseDisplayProps {
  resourceId: string;
  fileId: string;
  onComplete?: () => void;
  onBack?: () => void;
  isPreview?: boolean;
}

export function FreeResponseDisplay({ 
  resourceId, 
  fileId, 
  onComplete, 
  onBack, 
  isPreview 
}: FreeResponseDisplayProps) {
  const {
    questions,
    isLoading,
    isSubmitting,
    responses,
    attempt,
    isCompleted,
    isAdmin,
    handleResponseChange,
    handleSubmit
  } = useFreeResponse({
    resourceId,
    fileId,
    onComplete
  });

  if (isLoading) {
    return <FreeResponseLoading />;
  }

  if (questions.length === 0) {
    return <FreeResponseEmpty />;
  }

  const contextValue = {
    responses,
    isSubmitting,
    isCompleted,
    isAdmin,
    attempt,
    handleResponseChange,
    handleSubmit
  };

  // Display completed assessment view
  if (isCompleted && attempt?.completed_at) {
    return (
      <FreeResponseProvider value={contextValue}>
        <FreeResponseCompleted 
          questions={questions} 
          attempt={attempt} 
          onBack={onBack} 
        />
      </FreeResponseProvider>
    );
  }

  // Display normal assessment view (for non-completed attempts)
  return (
    <FreeResponseProvider value={contextValue}>
      <FreeResponseForm 
        questions={questions} 
        onBack={onBack} 
      />
    </FreeResponseProvider>
  );
}
